import soilDataConfigApi from '@/api/config/soilDataConfigApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function useSoilById(interfaceId: any, soilId: any) {
  return useQuery([[queryKeys.soil], soilId], async () => {
    if (!interfaceId || !soilId) return null
    const { data } = await soilDataConfigApi.getById(
      interfaceId.toString(),
      soilId.toString(),
    )
    if (!data) return null

    return data
  })
}

export default useSoilById
